import type {
    AnatomyBinding,
    AnatomyPart,
    AnatomyState,
    ComponentAnatomySpec,
} from "./componentAnatomy";
import { tagsInputSizes } from "./componentAnatomyTagsInputSizes";
import { tagsInputVariantSpecs } from "./componentAnatomyTagsInputVariants";

// Mined from designSystem/TagsInput/TagsInput.module.scss: the .root and
// .control blocks here, the size axis in componentAnatomyTagsInputSizes, the
// colour layer in componentAnatomyTagsInputVariants.

const parts: readonly AnatomyPart[] = [
    {
        id: "background",
        label: "Container",
        element: "wrapping flex .root, via --tags-input-bg",
    },
    {
        id: "border",
        label: "Border",
        element: "1px border on .root, via --tags-input-border",
    },
    {
        id: "chip",
        label: "Chip",
        element: 'one Tag size="lg" per value, label in BreakableText',
    },
    {
        id: "label",
        label: "Text / placeholder",
        element:
            "Base UI Input .control, via --tags-input-fg / --tags-input-placeholder",
    },
    {
        id: "focusRing",
        label: "Focus ring",
        element: "box-shadow on .root while focus is anywhere inside it",
    },
];

const states: readonly AnatomyState[] = [
    { id: "resting", label: "Default", selector: "" },
    {
        id: "hover",
        label: "Hover",
        selector:
            ':hover:not(:has(.control:disabled)):not([data-disabled]):not(:has(.control:read-only)):not(:focus-within):not([data-forced-state="focus"])',
    },
    { id: "focus", label: "Focus", selector: ":focus-within" },
];

const sharedBindings: readonly AnatomyBinding[] = [
    { partId: "background", property: "gap", token: "--space-4" },
    { partId: "border", property: "border-width", token: "--border-width" },
    { partId: "border", property: "border-radius", token: "--radius-m" },
    {
        partId: "chip",
        property: "height",
        literal: "28px",
        note: 'Tag size="lg" color="primary": its fill, text, padding and X button are listed in the Tag anatomy at lg.',
    },
    {
        partId: "label",
        property: "height",
        literal: "22px",
        note: "The 20px text line plus 1px above and below; centred in a chip row.",
    },
    {
        partId: "label",
        property: "min-width",
        literal: "min(200px, 50%)",
        note: "flex: 1 1 auto from a zero basis, so the input wraps to its own row below this.",
    },
];

export const tagsInputAnatomy: ComponentAnatomySpec = {
    label: "Tags input",
    schematic: "tagsInput",
    rootSelector: ".root",
    variantAxisLabel: "Variant",
    parts,
    states,
    sharedBindings,
    variants: tagsInputVariantSpecs,
    sizes: tagsInputSizes,
};
